import React, { useState } from "react";
import "../styles/BurgerMenu.css";
import Logo3D from "./Three.js/Logo3D";

const BurgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <>
      <div className="burger-icon" onClick={toggleMenu}>
        {isOpen ? "✖" : "☰"}
      </div>

      {isOpen && (
        <div className="burger-menu">
          <nav className="burger-nav">
            <a href="/">Accueil</a>
            <a href="/voyagez">Voyagez avec nous</a>
            <a href="/charter">Charter</a>

              <div className="burger-logo">
                <a href="/">
                  <Logo3D />
                </a>
              </div>

            <a href="/realisation">Nos Réalisations</a>
            <a href="/contact">Contact</a>
            <a href="/decouvrir">Découvrir</a>
          </nav>
        </div>
      )}
    </>
  );
};

export default BurgerMenu;
